import { React, PT, WithData, withRouter } from '@gasbuddy/react';
import BN from 'bignumber.js';
import { Dimmer, Loader, Table, Segment, Icon } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';

class BaseCoupons extends React.Component {
  state = {
    column: 'name',
    direction: 'ascending',
  }

  handleSort = clickedColumn => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        direction: 'ascending',
      });
    } else {
      this.setState({
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      });
    }
  }

  render() {
    const { column, direction } = this.state;
    const { data, loading, onSelected } = this.props;
    const { pending } = this.state;

    const dir = direction === 'ascending' ? 1 : -1;
    const coupons = data ? data.coupons.slice().sort((a, b) => {
      switch (column) {
        case 'id':
          return (a.coupon_id - b.coupon_id);
        case 'name':
          return (a.name.localeCompare(b.name)) * dir;
        case 'internal_name':
          return (a.internal_name.localeCompare(b.internal_name)) * dir;
        case 'coupon_type':
          return (a.coupon_type.localeCompare(b.coupon_type)) * dir;
        case 'discount_type':
          return (a.discount_type.localeCompare(b.discount_type)) * dir;
        case 'amount':
          return new BN(a.amount || 0).comparedTo(b.amount || 0) * dir;
        default:
          return 0;
      }
    }) : [];

    return (
      <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
        <Nav>
          <div>
            <h1>Coupons</h1>
            <Dimmer.Dimmable as={Segment} dimmed={loading || pending}>
              <Dimmer active={loading || pending}>
                <Loader />
              </Dimmer>
              <Table sortable striped selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell sorted={column === 'id' && direction} width={1} onClick={this.handleSort('id')}>Id</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'internal_name' && direction} onClick={this.handleSort('internal_name')}>Internal Name</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'coupon_type' && direction} onClick={this.handleSort('coupon_type')}>Coupon Type</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'name' && direction} onClick={this.handleSort('name')}>Name</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'discount_type' && direction} onClick={this.handleSort('discount_type')}>Discount Type</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'amount' && direction} onClick={this.handleSort('amount')}>Amount</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Eligibility Rules</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {coupons.map(d => (
                    <Table.Row
                      key={d.internal_name}
                      onClick={() => onSelected(d.coupon_id)}
                    >
                      <Table.Cell>{d.coupon_id}</Table.Cell>
                      <Table.Cell>{d.internal_name}</Table.Cell>
                      <Table.Cell>{d.coupon_type}</Table.Cell>
                      <Table.Cell>{d.name}</Table.Cell>
                      <Table.Cell textAlign="center">{d.discount_type}</Table.Cell>
                      <Table.Cell textAlign="center">
$
                        {d.amount ? new BN(d.amount).toFormat(2) : '-'}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        {(d.eligibility && Object.keys(d.eligibility).length) ? <Icon name="checkmark" /> : null}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseCoupons.propTypes = {
  data: PT.shape({
    coupons: PT.arrayOf(PT.shape({
      name: PT.string,
    })),
  }),
  loading: PT.bool,
  onSelected: PT.func.isRequired,
};

BaseCoupons.defaultProps = { loading: false, data: null };

export const Coupons = withRouter(({ history }) => (
  <WithData url="/payments/coupons">
    <BaseCoupons
      onSelected={id => history.push(`/payments/coupons/${id}`)}
    />
  </WithData>
));
